import Agilite from 'agilite'
import store from '../../../../store'
import { GlobalServicesEnums } from './enums'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const createGlobalService = async (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      const agiliteUser = store.getState().auth.agiliteUser
      const payload = {
        ...data,
        createdBy: agiliteUser._id,
        modifiedBy: agiliteUser._id,
        createdAt: new Date(),
        modifiedAt: new Date()
      }
      try {
        // Fetch Bookings First
        let response = await agilite.Connectors.execute(
          GlobalServicesEnums.profileKeys.GLOBAL_SERVICES,
          GlobalServicesEnums.routeKeys.CREATE,
          {
            data: JSON.stringify(payload)
          }
        )
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
export const readGlobalServices = async (filter, page, pageNumber) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        // Fetch Bookings First
        let response = await agilite.Connectors.execute(
          GlobalServicesEnums.profileKeys.GLOBAL_SERVICES,
          GlobalServicesEnums.routeKeys.READ,
          {
            filter: JSON.stringify(filter)
          }
        )
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
export const updateGlobalServiceByID = async (recordId, data) => {
  const agiliteUser = store.getState().auth.agiliteUser
  const payload = {
    ...data,
    modifiedBy: agiliteUser._id,
    modifiedAt: new Date()
  }
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        // Fetch Bookings First
        let response = await agilite.Connectors.execute(
          GlobalServicesEnums.profileKeys.GLOBAL_SERVICES,
          GlobalServicesEnums.routeKeys.UPDATE_BY_ID,
          {
            recordId,
            data: JSON.stringify(payload)
          }
        )
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
export const deleteGlobalServiceByID = async (recordId) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        // Fetch Bookings First
        let response = await agilite.Connectors.execute(
          GlobalServicesEnums.profileKeys.GLOBAL_SERVICES,
          GlobalServicesEnums.routeKeys.DELETE_BY_ID,
          {
            recordId
          }
        )
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
